module.exports = __webpack_public_path__ + "static/ube-bread-72a129e019a1fd81768d8b9f9cfa30ae.jpg";